<template lang="pug">
  app-toolbar(title="Заявки на оплату")
    app-toolbar-item(label="Показать" :items="preparedStatuses" key-name="title" min-width="216" @select="filterByStatus") {{ selectedStatus | statusNamed }}
      template(slot="list-item" slot-scope="{ item, index }" ) 
        span.sud-case-status-color(v-bind:style="{ background: statusColor(item) }")
        span.sud-case-filter.text-lowercase {{ item.title }}

    app-toolbar-item-period.ml-12(@select="setPeriod") {{ period ? period.text : 'все' }} 

    app-dialog-loading(v-model="updating")
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { $_app_moment } from "@/common/AppMoment.js"
import AppStatuses from "@/assets/data/SpecAppStatuses.json"
import { $_user_role as Role } from '@/common/UserUtils'

import { AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogLoading.name]: AppDialogLoading
  },
  mixins: [ $_app_moment ],
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapState('specialist', ['selectedStatus', 'period', 'updating']),
    ...mapGetters('specialist', ['statuses', 'isStatusesLoaded']),
    ...mapGetters('me', ['hasRole']),
    isBuh() {
      return this.hasRole([Role.accountant])
    },
    preparedStatuses () {
      let lastColor = 0
      let list = []

      if(this.isBuh){
        for (let index = 1; index < this.statuses.length; index++) {
          const element = this.statuses[index]
          if(element.name=="CONFIRM" || element.name=="INREESTR")
            list.push(element)
        }
      } else {
        list.push({ title: 'Все', color: 0 })
        list.push({ divider: true })
        for (let index = 1; index < this.statuses.length; index++) {
          const element = this.statuses[index]
        
          if (lastColor != 0 && lastColor != element.color) {
            list.push({ divider: true })
          }
          lastColor = element.color
          list.push(element)
        }
      }
      return list
    }
  },

  methods: {
    ...mapMutations('specialist', [ 'selectStatus', 'setPeriod']),

    statusColor(item) {
      if (item.color > 0 && item.color < 4) {
        return AppStatuses.colors[item.color]
      }
      return ''
    },

    filterByStatus(status) {
      if (status.color!=0) 
        this.selectStatus(status)
      else 
        this.selectStatus(null)
    },

  },
  filters: {
    statusNamed: status => {
      return status != null ? status.title : 'Все'
    },
  },

}
</script>


<style lang="scss" scoped>
  .sud-card-text {
    background: #FFFFFF; 
  }

  .sud-case-status-color {
    margin: 0 16px 0 0;
  }
</style>
